import cx from 'classnames';
import { useMemo } from 'react';
import VehicleMakeIcon from '@/common/VehicleMakeIcon';
import { useGetVehicleDetails } from '~/context/vdp/VehicleContext';
import optimizeImage from '~/utilities/optimizeImage';
import useWhyBuyStillImage from './hooks/useWhyBuyStillImage';
import { HeroImage, Placeholder } from './WhyBuyMakePlaceholder.styles';

type Variant = 'card' | 'modal';

type OwnProps = {
  variant?: Variant;
};

const VARIANTS: Record<
  Variant,
  { heroWidth: number; logo?: string; logoSize: number }
> = {
  card: { heroWidth: 680, logoSize: 53 },
  modal: {
    heroWidth: 1080,
    logo: 'h-auto w-[22%]',
    logoSize: 60
  }
};

export default function WhyBuyMakePlaceholder({ variant = 'card' }: OwnProps) {
  const { make, vexVdpImageData: { heroes: { hero = '' } = {} } = {} } =
    useGetVehicleDetails();
  const { heroWidth, logo, logoSize } = VARIANTS[variant];
  const heroUrl = useMemo(
    () => optimizeImage(hero, { width: heroWidth }),
    [hero, heroWidth]
  );
  const { url: loadedHeroUrl } = useWhyBuyStillImage(
    heroUrl,
    'WhyBuyMakePlaceholder'
  );

  return (
    <Placeholder data-testid="why-buy-media-placeholder">
      {loadedHeroUrl && (
        <HeroImage
          alt=""
          aria-hidden
          data-testid="why-buy-placeholder-hero"
          draggable={false}
          src={loadedHeroUrl}
        />
      )}
      <VehicleMakeIcon
        aria-hidden
        className={cx('relative grayscale opacity-40', logo)}
        data-testid="why-buy-make-logo"
        make={make}
        size={logoSize}
      />
    </Placeholder>
  );
}
